'use client';

import { FaRepeat } from 'react-icons/fa6';

import { SecondaryButton } from '@web/ui';

import styles from './RepeatTaskButton.module.scss';

type RepeatTaskButtonProps = {
  isRecurring: boolean;
  readOnly?: boolean;
  onToggle?: () => void;
};

export function RepeatTaskButton({
  isRecurring,
  readOnly = false,
  onToggle,
}: RepeatTaskButtonProps) {
  const button = (
    <SecondaryButton
      ariaLabel="Recurring Monthly • Creates a new instance each month"
      variant="medium"
      backgroundOverride="theme"
      style={
        isRecurring
          ? {
              backgroundColor: 'var(--nn-accent-green)',
              color: 'var(--nn-white)',
            }
          : undefined
      }
      onClick={() => {
        if (readOnly) {
          return;
        }
        onToggle?.();
      }}
    >
      <FaRepeat
        style={{
          color: isRecurring ? 'var(--nn-white)' : 'inherit',
        }}
      />
    </SecondaryButton>
  );

  if (readOnly) {
    return (
      <div
        className={`${styles.repeatTaskButton} ${styles.repeatTaskButtonDisabled}`}
      >
        {button}
      </div>
    );
  }

  return <div className={styles.repeatTaskButton}>{button}</div>;
}
